<template>
  <v-footer app inset dark>
    <v-flex class="az-about">
      <span class="az-about__copywrite"> &copy;{{ yearCopywrite }} — {{ companyCopywrite }} </span>
      <span class="az-about__version"> {{ versionNumber }} </span>
    </v-flex>
    <v-img src="/icons/icon-dente-delta-v1.png" max-height="24" max-width="24"/>
  </v-footer>
</template>

<script>
export default {
    name: 'core-footer',
    computed: {
        versionNumber() {
            return process.env.APP_VERSION
        },
        yearCopywrite() {
            return new Date().getFullYear()
        },
        companyCopywrite() {
            return this.$store.state.comum.nomeSistema
        },
    },
}
</script>

<style scoped lang="stylus">
.az-about
  height 36px
  color #7f7f7f
  font-size 14px
  font-weight normal
  -webkit-box-align center
  -ms-flex-align center
  align-items center
  display -webkit-box
  display -ms-flexbox
  display flex
  justify-content space-between

  .theme--light.v-footer
    background none !important

  &__copywrite
    padding-left 20px

  &__version
    padding-right 20px


</style>